// socket-events.js



let allowReconnection = true;
export default async function setupSocketListeners(socket, _vue) {

    let app = _vue;




    



    socket.on('connect', () => {
        app.onConnected();
        setTimeout(() => {
            socket.emit('getCore');
            socket.emit('getPopularUsers');
        }, 500);
       
    });

    socket.on('your_key', (data) => {
        app.securityDetails = data;
        socket.authKeyUnique = data;
    });

    socket.on('welcome', (data) => {
        if (data.length > 0) {
            for (let index = 0; index < data.length; index++) {
                socket.emit('join', { id: data[index].id, name: data[index].name, autojoin: 1 });
            }
        }
    });

    socket.on('popularUsers', (data) => {
        if (data.length > 0) {
            data = data.map(user => {
                return {
                   ...user,
                   id: user._id,
                }
            })
        }
        app.updatePopulerUsers(data);
    })

    socket.on('audioChatToken', (data) => {
        app.updateAudioChatToken(data);
    })

    

    socket.on('follow_list', (data) => {
        if (data) {
            app.followList = data;
        }
    });
    socket.on('addFollow', (data) => {
        if (data && !app.followList.find(c => c._id === data._id)) {
            app.followList.push(data);
        }
    });
    socket.on('removeFollow', (data) => {
        app.followList = app.followList.filter(c => c.id !== data);
    });

    

    socket.on('newChannelMessage', (data) => {
        app.pushChannelMessage(data);
    });


    socket.on('channelDetails', (data) => {
        console.log(data);
    });

    socket.on('names', (data) => {
        if (app.defaultSelectedUser) {   
            return;
        }

        if (!data) {
            return;
        }
        

        const exists = app.conversations.find(conversation => conversation.id === data.id);
        if (!exists) {
            if (!data.levels.some(level => level.access === 0)) {
                data.levels.push({ id: 0, title: "Users", color: "grey", access: 0 });
            }
            data.typing = [


            ];
            app.conversations.push(data);
            app.updateSelected(data.id);
        } else {
            exists.users = data.users;
        }


        app.updateChannelUsersLevels(data.id);
    })


    socket.on('admin_levels', (data) => {
        const userLevel = data.admin_levels
            .sort((a, b) => b.access - a.access)
            .find(level => app.my_profile.access >= level.access);
        app.my_profile.userLevel = userLevel;

        app.GlobalAdminLevels = data.admin_levels;
    });

    socket.on('your_profile', (data) => {
        app.my_profile = data;
    })
    socket.on('gifts', (data) => {
        app.giftList = data;
    })
    

    socket.on('reloadChannelManager', (data) => {
        socket.emit('manageChannel', data.channel_id);
    })

    socket.on('k-line', (data) => {
        app.showKlinePopup(data);
    })

    socket.on('klineList', (data) => {
        app.showKlineList(data);
    })
    

    socket.on('getNewJWT', (data) => {
        socket.emit('joinAudioChat', data.channel_id)
    })

    socket.on('yourGoldAndPremium', (data) => {
        app.afterPaymentProcess(data);
    })
    
    socket.on('user_info', (data) => {
        if (typeof data.nickname === 'undefined') {
            let channel = app.conversations.find(conversation => conversation.user_id === data.user_id);
            if (channel) {
                channel.profile = { nickname: channel.name, avatar: channel.avatar }
            }
        } else {
            let channel = app.conversations.find(conversation => conversation.user_id === data.user_id);
            if (channel) {
                
                for (const property in data) {
                    if (property == 'avatar' && !channel.profile[property]) {
                        channel.profile[property] = channel.avatar;
                        continue;
                    }
                    channel.profile[property] = data[property];
                }
                channel.profile.age = data.age;
            }
        }
    });

    socket.on('typing', (data) => {
        const channel = app.conversations.find(conversation => conversation.id === data.conversation_id);
        if (channel) {
            const userInChannel = channel.users.find(user => user.user_id === data.user_id);

            if (userInChannel) {
                let userTyping = channel.typing.find(user => user.user_id === data.user_id);

                if (!userTyping) {
                    userTyping = { nickname: userInChannel.nickname, user_id: data.user_id, timer: null };
                    channel.typing.push(userTyping);
                } else {
                    clearTimeout(userTyping.timer);
                }
                userTyping.timer = setTimeout(() => {
                    channel.typing = channel.typing.filter(user => user.user_id !== data.user_id);
                }, 1000);
            }

        }
    });

    socket.on('joined', (data) => {
        app.userJoinToChannel(data);
    })
    socket.on('parted', (channelId) => {
        const channelIndex = app.conversations.findIndex(conversation => conversation.id === channelId);
        if (channelIndex !== -1) {
            app.conversations.splice(channelIndex, 1);
            if (app.conversations.length > 0) {
                const lastChannel = app.conversations[app.conversations.length - 1];
                if (lastChannel.id === 0 && lastChannel.user_id) {
                    app.updateSelected(lastChannel.user_id * -1);
                } else {
                    app.updateSelected(lastChannel.id);
                }
            }
        }
    });
    socket.on('api_settings', (data) => {
        app.loadApiSettings(data);
    })

    socket.on('userLeft', (data) => {
        const channel = app.conversations.find(conversation => conversation.id === data.channel_id);
        if (channel) {
            const userInChannel = channel.users.find(user => user.user_id === data.user_id);
            if (userInChannel) {
                channel.users = channel.users.filter(user => user.user_id !== data.user_id);
            } else {
                console.log('user not found');
            }
        } else {
            console.log('channel not found');
        }
    });

    socket.on('privMessage', (data) => {
        app.pushPrivateMessage(data);
    });

    socket.on('conversations_list', (list) => {
        list.forEach((conversation) => {
            const channel = app.conversations.find(c => c.id === conversation.conversation_id);
            if (!channel) {
                app.conversations.push({
                    _id: conversation._id,
                    id: conversation.conversation_id,
                    user_id: conversation.other_user_id,
                    name: conversation.other_user_nickname,
                    avatar: conversation.other_user_avatar || '',
                    is_audio: false,
                    levels: [],
                    users: [],
                    messages: [],
                    typing: [],
                    topic: '',
                    private: true,
                    unread: conversation.unread_count,
                    get_messages: false,
                    online:conversation.other_user_online,
                    profile: {}
                });

                if (app.defaultSelectedUser == conversation.conversation_id) {
                    setTimeout(() => {
                        app.updateSelected(conversation.conversation_id);

                    }, 200);
                }

            }  else {
                channel.messages= [];
                channel.get_messages = true;
            }
        });
    });

    socket.on('PMforConv', (data) => {
        const channel = app.conversations.find(conversation => conversation.id === data.id);
        const index = app.conversations.findIndex(conversation => conversation.id === data.id);
        if (channel) {
            data.messages.forEach(message => {
                channel.messages.unshift(message);
            });
        }
        if (index !== -1) {
            app.setUnreadMessages(index);
        }
    });

    socket.on('profile_update', data => {
        if (data.status == false) {
            app.showToast({ severity: 'error', summary: 'error', detail: data.message });
        } else {
            app.showToast({ severity: 'info', summary: 'Info', detail: 'Profile updated' });
        }
    })

    socket.on('online', data => {
        app.setOnline(data.user_id);
    })

    socket.on('offline', data => {
        app.setOffline(data.user_id);
    })

    socket.on('channelDetails', (data) => {
        app.openChannelDetails(data);
    })

    socket.on('userKick', (data) => {
        const channel = app.conversations.find(conversation => conversation.id === data.channel_id);
        if (channel) {
            if (data.user_id === app.my_profile.user_id) {
                app.showToast({ severity: 'error', summary: 'error', detail: 'You are kicked from the #' + channel.name + '.' + (data.reason ? '(Reason:' + data.reason + ')' : '') });
                app.conversations = app.conversations.filter(conversation => conversation.id !== data.channel_id);
                app.updateSelected(0);
            } else {
                channel.users = channel.users.filter(user => user.user_id !== data.user_id);
            }
        }
    })
    socket.on('accessChanged', (data) => {
        const channel = app.conversations.find(conversation => conversation.id === data.channel_id);
        if (channel) {
            channel.users = channel.users.map(user => {
                if (user.user_id === data.user_id) {
                    user.access = data.access;
                }
                return user;
            });
        }
    })

    socket.on('levelChanged', (data) => {
        const channel = app.conversations.find(conversation => conversation.id === data.channel_id);
        if (channel) {
            channel.levels = data.levels;
        }
    });
    socket.on('user_avatarChange', (data) => {
        app.conversations = app.conversations.map(conversation => {
            if (conversation.users.find(user => user.user_id == data.user_id)) {
                conversation.users = conversation.users.map(user => {
                    if (user.user_id == data.user_id) {
                        user.avatar = data.avatar
                    }
                    return user
                })
            }
            if (conversation.user_id == data.user_id) {
                conversation.avatar = data.avatar
            }
            return conversation;
        })

        if (data.user_id == app.my_profile.user_id) {
            app.updateAvatar(data.avatar);
        }
    });



    socket.on('error_msg', (data) => {
        app.processError(data);
    })
    socket.on('info_msg', (data) => {
        app.showToast({ severity: 'info', summary: app.$t('error_messages.info'), detail: data.message });
    });

    socket.on('conversation_removed', (id) => {
        const conversation = app.conversations.find(conversation => conversation.id === id);
        if (conversation) {
            app.showToast({ severity: 'error', summary: 'Info', detail: 'Conversation removed with ' + conversation.name });
            app.conversations = app.conversations.filter(conversation => conversation.id !== id);
            app.updateSelected(app.conversations[app.conversations.length - 1].id);
        }
    });

    socket.on('duplicate_login', () => {
        app.showDumplicated();
        allowReconnection = false;
        socket.disconnect();
    });

    socket.on('updateGolds', (gold) => {
        app.my_profile.golds = gold;
    });

    socket.on('notifications', (data) => {
        app.notifications = data;
    });

    socket.on('giftSent', (data) => {
        app.showToast({ severity: 'success', summary: 'Gift sent', detail: 'Gift sent with ' + data.price + ' golds.' });
    });
    
    socket.on('giftReceived', (data) => {
       app.notifications.push(data);
    });
    

    socket.on('boughtContent', (data) => {
        console.log(data);
        app.showToast({ severity: 'success', summary: 'Content Unlocked', detail: 'Content Unlocked with ' + data.price + ' golds.' });
        app.boughtContents.push({content_id: data.content_id, token: data.token});
    })

    
    socket.on('contentsList', (data) => {
        if (data && data.length > 0) {
           data.forEach(content => {
            app.boughtContents.push(content);
           })
        }
    })

    socket.on('blockList', (data) => {
        app.updateBlockedUsers(data);
    });

    socket.on('settings', (data) => {
        app.loadSettings(data);
    });


    socket.on('deleteMessage', (data) => {
        app.deleteMessage(data);
    });

    

    
    socket.on('globalSettings', (data) => {
        app.loadGlobalSettings(data);
    });

    socket.on('products', (data) => {
        app.loadProducts(data);
    });

    socket.on('channelList', (data) => {
        app.loadChannelList(data);
    });

    socket.on('goldNotEnough', (data) => {
        app.goldNotEnough(data);
    });
    socket.on('channelWaitingList', (data) => {
        app.channelWaitingList(data);
    });
    

    socket.on('disconnect', () => {
        if (allowReconnection) {
            app.reConnect();
        }
    });

    socket.on('error', () => {
        if (allowReconnection && !socket.connected) {
            app.reConnect();
        }
    });

    

    socket.on('popularAdded', (data) => {
        const expiresAt = data.expires_at;
        const expiresDate = new Date(expiresAt);
        const formattedDate = expiresDate.toLocaleString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
        app.showPopularCompleted(formattedDate);
    });


}
